import { BehaviorSubject } from 'rxjs';
import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';
import { registerLocaleData } from '@angular/common';

const ANGULAR_DEFAULT_LOCALE: string = 'en-US';

interface ILocale {
	language: string;
	bcp47Locale: string;
	ckEditorLocale: string;
	fullcalendarLocale: string;
	momentLocale: string;
}

const localeSubject$ = new BehaviorSubject<ILocale>(toLocale(BootstrapContext));

export const locale$ = localeSubject$.asObservable();

export function getLocale(): ILocale {
	return localeSubject$.value;
}

function toLocale(localeData: Partial<ILocale>): ILocale {
	return {
		language: localeData.language,
		bcp47Locale: localeData.bcp47Locale,
		ckEditorLocale: localeData.ckEditorLocale,
		fullcalendarLocale: localeData.fullcalendarLocale,
		momentLocale: localeData.momentLocale
	};
}

export function updateLocale(localeData: any): void {
	localeSubject$.next(toLocale(localeData));

	importLocale(localeData.bcp47Locale);
}

export function initLocale(): void {
	importLocale(BootstrapContext.bcp47Locale);
}

function importLocale(bcp47Locale: string): Promise<void> {
	if (bcp47Locale !== ANGULAR_DEFAULT_LOCALE) {
		let localeImport: Promise<{ default: any }>;
		switch (bcp47Locale) {
			case 'de':
				localeImport = import('@angular/common/locales/de');
				break;
			case 'en':
				localeImport = import('@angular/common/locales/en');
				break;
			case 'en-GB':
				localeImport = import('@angular/common/locales/en-GB');
				break;
			case 'es':
				localeImport = import('@angular/common/locales/es');
				break;
			case 'es-AR':
				localeImport = import('@angular/common/locales/es-AR');
				break;
			case 'es-MX':
				localeImport = import('@angular/common/locales/es-MX');
				break;
			case 'fr':
				localeImport = import('@angular/common/locales/fr');
				break;
			case 'it':
				localeImport = import('@angular/common/locales/it');
				break;
			case 'ja':
				localeImport = import('@angular/common/locales/ja');
				break;
			case 'ko':
				localeImport = import('@angular/common/locales/ko');
				break;
			case 'nl':
				localeImport = import('@angular/common/locales/nl');
				break;
			case 'pt':
				localeImport = import('@angular/common/locales/pt');
				break;
			case 'ru':
				localeImport = import('@angular/common/locales/ru');
				break;
			case 'sv':
				localeImport = import('@angular/common/locales/sv');
				break;
			case 'tr':
				localeImport = import('@angular/common/locales/tr');
				break;
			case 'zh-Hans':
				localeImport = import('@angular/common/locales/zh-Hans');
				break;
			case 'zh':
				localeImport = import('@angular/common/locales/zh');
				break;
			case 'id':
				localeImport = import('@angular/common/locales/id');
				break;
			default:
				console.warn(`Locale ${bcp47Locale} not supported.`);
				return Promise.resolve(); // nothing to import
		}

		return localeImport!.then(({ default: localeData }) => {
			registerLocaleData(localeData, bcp47Locale);
		});
	}

	return Promise.resolve();
}
